import { render, staticRenderFns } from "./RecommendItem.vue?vue&type=template&id=2f5bb48b&scoped=true"
import script from "./RecommendItem.vue?vue&type=script&lang=js"
export * from "./RecommendItem.vue?vue&type=script&lang=js"
import style0 from "./RecommendItem.vue?vue&type=style&index=0&id=2f5bb48b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5bb48b",
  null
  
)

export default component.exports